/**
 * EventPrintForm constants
 */
export const FORM_NAME = 'eventPrintForm';
